"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_resolve_hypermedia_1 = require("@comunica/bus-rdf-resolve-hypermedia");

var RdfSourceSparql_1 = require("./RdfSourceSparql");
/**
 * A comunica SPARQL RDF Resolve Hypermedia Actor.
 */


var ActorRdfResolveHypermediaSparql =
/*#__PURE__*/
function (_bus_rdf_resolve_hype) {
  _inherits(ActorRdfResolveHypermediaSparql, _bus_rdf_resolve_hype);

  function ActorRdfResolveHypermediaSparql(args) {
    _classCallCheck(this, ActorRdfResolveHypermediaSparql);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfResolveHypermediaSparql).call(this, args, 'sparql'));
  }

  _createClass(ActorRdfResolveHypermediaSparql, [{
    key: "testMetadata",
    value: function () {
      var _testMetadata = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!action.forceSourceType && !action.metadata.sparqlService)) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Actor ".concat(this.name, " could not detect a SPARQL service description."));

              case 2:
                return _context.abrupt("return", {
                  filterFactor: 1
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testMetadata(_x) {
        return _testMetadata.apply(this, arguments);
      }

      return testMetadata;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var source;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.logInfo(action.context, "Identified as sparql source: ".concat(action.url));
                source = new RdfSourceSparql_1.RdfSourceSparql(action.metadata.sparqlService || action.url, action.context, this.mediatorHttp);
                return _context2.abrupt("return", {
                  source: source
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorRdfResolveHypermediaSparql;
}(bus_rdf_resolve_hypermedia_1.ActorRdfResolveHypermedia);

exports.ActorRdfResolveHypermediaSparql = ActorRdfResolveHypermediaSparql;